import { render, staticRenderFns } from "./Tips.vue?vue&type=template&id=4ae2e4a4&scoped=true&"
import script from "./Tips.vue?vue&type=script&lang=js&"
export * from "./Tips.vue?vue&type=script&lang=js&"
import style0 from "./Tips.vue?vue&type=style&index=0&id=4ae2e4a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae2e4a4",
  null
  
)

export default component.exports